import { useEffect, useState } from "react";
import CustomModel from "../../Utility/CustomModel";
import {
  addReferenceTitle,
  referenceListing,
} from "../../Utility/referenceListing";
import { PanelRefAuthorGroup } from "./PanelRefAuthGroup";

const PanelReferenceForm = ({ handleCancel, editor, show }) => {
  const fields = [
    {
      name: "reftype",
      label: "REFERENCE TYPE",
      type: show?.add?.open ? "select" : "text",
      options: ["article-journal", "book", "conf-proc"],
      default: "article-journal",
      editable: show?.add?.open,
      field: true,
    },
    {
      name: "position",
      label: "REFERENCE POSITION",
      type: "select",
      options: ["Add After", "Add Before"],
      default: "Add After",
      editable: show?.add?.open,
      field: show?.add?.open ? true : false,
    },
    // {
    //   name: "label",
    //   label: "LABEL",
    //   type: "text",
    //   default: "",
    //   editable: false,
    //   field: true,
    // },
    {
      name: "person-group",
      label: "AUTHOR GROUP",
      type: "text",
      default: "",
      editable: false,
      allowEdit: true,
      field: true,
    },
    {
      name: "article-title",
      label: "ARTICLE TITLE",
      type: "text",
      default: "",
      editable: true,
      field: true,
    },
    {
      name: "source1",
      label: "JOURNAL TITLE",
      type: "text",
      default: "",
      editable: true,
      field: true,
    },
    {
      name: "publisher-name",
      label: "PUBLISHER NAME",
      type: "text",
      default: "",
      editable: true,
      field: true,
    },
    {
      name: "year",
      label: "YEAR",
      type: "text",
      default: "",
      editable: true,
      field: true,
    },
    {
      name: "volume",
      label: "VOLUME",
      type: "text",
      default: "",
      editable: true,
      field: true,
    },
    {
      name: "issue",
      label: "ISSUE",
      type: "text",
      default: "",
      editable: true,
      field: true,
    },
    {
      name: "fpage",
      label: "FIRST PAGE",
      type: "text",
      default: "",
      editable: true,
      field: true,
    },
    {
      name: "lpage",
      label: "LAST PAGE",
      type: "text",
      default: "",
      editable: true,
      field: true,
    },
    {
      name: "pub-id",
      label: "DOI NUMBER",
      type: "text",
      default: "",
      editable: true,
      field: true,
    },
  ];

  const [formData, setFormData] = useState(() => {
    const initial = {};
    fields.forEach((field) => {
      initial[field.name] = field?.default || "";
    });
    return initial;
  });

  const [editableFields, setEditableFields] = useState({});
  const [authGroup, setAuthGroup] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEditClick = (fieldName, val) => {
    setEditableFields((prev) => ({
      ...prev,
      [fieldName]: { open: true, value: val },
    }));
  };

  const handleClose = () => {
    setEditableFields({});
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const refs = editor?.dom?.select("ref");

    if (refs && show?.edit?.open) {
      const matchingRef = Array.from(refs).find(
        (ref) => ref.getAttribute("id") === show.edit.id
      );

      const citation = matchingRef?.querySelector("mixed-citation");
      const refOutput = matchingRef?.querySelector('[data-ref="ref-output"]');

      if (refOutput) {
        //  Clear existing ref-output children
        while (refOutput.firstChild) {
          refOutput.removeChild(refOutput.firstChild);
        }

        if (authGroup?.length > 0) {
          const personGroup = editor?.dom?.create("person-group");
          personGroup.setAttribute("person-group-type", "author");

          authGroup.forEach((author) => {
            const stringName = editor?.dom?.create("string-name");

            Object.entries(author).forEach(([key, val]) => {
              const trimmedVal = val?.trim?.();
              if (trimmedVal) {
                const tagNode = editor?.dom?.create(key);
                tagNode.textContent = val;
                stringName.appendChild(tagNode);
              }
            });

            if (stringName.childNodes.length > 0) {
              personGroup.appendChild(stringName);
            }
          });

          if (personGroup.childNodes.length > 0) {
            refOutput.appendChild(personGroup);
          }
        }
        //  Define fields to skip
        const skipFields = ["reftype", "label", "person-group", "position"];

        // Loop through formData and append valid tags
        Object.entries(formData).forEach(([tag, value]) => {
          const trimmed = value?.trim?.();
          if (trimmed && !skipFields.includes(tag)) {
            const tagEl = editor?.dom?.create(tag);
            tagEl.textContent = value;
            refOutput.appendChild(tagEl);
          }
        });
      }
    } else if (refs && show?.add?.open) {
      const matchingRef = Array.from(refs).find(
        (ref) => ref.getAttribute("id") === show.add.id
      );
      const refID = parseInt(matchingRef.id.match(/\d+/)[0], 10);
      const newRef = editor?.dom?.create("ref");
      newRef.setAttribute(
        "id",
        `ref-${formData?.position == "Add Before" ? refID - 1 : refID + 1}`
      );

      const refOutput = editor?.dom?.create("refoutput");
      refOutput.setAttribute("data-ref", "ref-output");
      refOutput.setAttribute("data-edit", "edit");
      refOutput.setAttribute("data-lock", "false");
      refOutput.setAttribute("contenteditable", "true");
      refOutput.setAttribute("contenteditable", "true");
      if (authGroup?.length > 0) {
        const personGroup = editor?.dom?.create("person-group");
        personGroup.setAttribute("person-group-type", "author");

        authGroup.forEach((author) => {
          const stringName = editor?.dom?.create("string-name");

          Object.entries(author).forEach(([key, val]) => {
            const trimmedVal = val?.trim?.();
            if (trimmedVal) {
              const tagNode = editor?.dom?.create(key);
              tagNode.textContent = val;
              stringName.appendChild(tagNode);
            }
          });

          if (stringName.childNodes.length > 0) {
            personGroup.appendChild(stringName);
          }
        });

        if (personGroup.childNodes.length > 0) {
          refOutput.appendChild(personGroup);
        }
      }

      //  Define fields to skip
      const skipFields = ["reftype", "label", "person-group", "position"];

      // Loop through formData and append valid tags
      Object.entries(formData).forEach(([tag, value]) => {
        const trimmed = value?.trim?.();
        if (trimmed && !skipFields.includes(tag)) {
          const tagEl = editor?.dom?.create(tag);
          tagEl.textContent = trimmed;
          refOutput.appendChild(tagEl);
        }
      });

      newRef.appendChild(refOutput);

      // Append the new reference to the document
      if (formData?.position == "Add Before") {
        matchingRef.parentNode.insertBefore(newRef, matchingRef);
      } else {
        editor.dom.insertAfter(newRef, matchingRef);
      }
      referenceListing(editor);
      addReferenceTitle(editor);
    }
    handleCancel();
  };

  useEffect(() => {
    
    const refs = editor?.dom?.select("ref");
    if (refs && show?.edit?.open) {
      const matchingRef = Array.from(refs).find(
        (ref) => ref.getAttribute("id") === show.edit.id
      );
      let refOutput = matchingRef?.querySelector('[data-ref="ref-output"]');
      if (refOutput) {
        const updatedData = {};
        const children = refOutput.children;
        const reftype = refOutput.getAttribute("publication-type");
        for (let child of children) {
          let tag = child.tagName.toLowerCase();

          if (tag === "person-group") {
            const authors = [];
            const authgroup = [];

            // Build the author string (e.g., "S. Shafi, A. V. Parwani")
            child.querySelectorAll("string-name").forEach((nameNode) => {
              const allParts = Array.from(nameNode.children)
                .map((el) => el.textContent.trim())
                .filter(Boolean); // remove empty or null

              if (allParts.length) {
                authors.push(allParts.join(" "));
              }
            });

            // Build the structured author data array
            child.querySelectorAll("string-name").forEach((value) => {
              const authorObj = {};

              value.childNodes.forEach((node) => {
                if (node.nodeType === 1) {
                  const tag = node.tagName?.toLowerCase();
                  const text = node.textContent?.trim() || "";
                  authorObj[tag] = text;
                }
              });

              authgroup.push(authorObj);
            });

            // Store final string for display
            updatedData["person-group"] = authors.join(", ");

            // Safely update editableFields even if authorData field does not exist
            setAuthGroup(authgroup);
          } else {
            updatedData[tag] = child.textContent?.trim() || "";
          }
        }

        // Update React state
        setFormData((prev) => ({
          ...prev,
          ...updatedData,
          reftype: reftype || prev.reftype,
        }));
      }
    } else if ( show?.add?.open) {
      
      setFormData(() => {
        const initial = {};
        fields.forEach((field) => {
          initial[field.name] = field?.default || "";
        });
        return initial;
      });
    }
  }, [
    show?.add?.open,
    show?.edit?.open,
    show?.add?.id,
    show?.edit?.id,
    editor,
  ]);

  return (
    <div className="w-full h-full">
      <div className="border-b border-grey p-3  absolute top-0 bg-leftPanelbg inset-x-0 z-[10] ">
        <h4 className="font-semibold text-primary text-[18px]">
          {show?.add?.open ? "Add" : "Edit"} Reference
        </h4>
      </div>
      <div className="w-full mt-10">
        <form onSubmit={handleSubmit} className="w-full h-full py-4">
          {fields.map((field, index) => {
            const isEditable = field.editable || false;

            const isTrulyReadOnly = !field.editable;

            const inputStyle = {
              padding: "6px 10px",
              flexGrow: 1,
              ...(isTrulyReadOnly
                ? {
                    border: "1px solid #ccc",
                    outline: "none",
                    backgroundColor: "#f9f9f9",
                  }
                : { border: "1px solid #ccc", outline: "none" }),
            };

            return (
              <div
                key={index}
                className="mb-[12px] flex flex-col w-full  gap-[10px]"
              >
                {field.field && (
                  <label className="ref-form-label text-16 text-primary font-medium ">
                    {field.label}
                  </label>
                )}
                <div className="flex gap-2">
                  {field.type === "select" && field.field ? (
                    <select
                      name={field.name}
                      value={formData[field.name]}
                      onChange={handleChange}
                      style={inputStyle}
                      className="cursor-pointer text-primary"
                    >
                      {field.options.map((opt, i) => (
                        <option
                          className="cursor-pointer text-primary"
                          key={i}
                          value={opt}
                        >
                          {opt}
                        </option>
                      ))}
                    </select>
                  ) : (
                    field.type === "text" && (
                      <input
                        className="text-primary"
                        type={field.type}
                        name={field.name}
                        value={formData[field.name]}
                        onChange={handleChange}
                        style={inputStyle}
                        readOnly={!isEditable}
                      />
                    )
                  )}

                  {/* Only show "Edit" button if allowEdit is true and not already editable */}
                  {!isEditable && field.allowEdit && (
                    <button
                      className="text-primary"
                      type="button"
                      onClick={() =>
                        handleEditClick(
                          field.name,
                          show.edit?.open ? true : false
                        )
                      }
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        class="icon icon-tabler icons-tabler-outline icon-tabler-edit"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                        <path d="M7 7h-1a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-1" />
                        <path d="M20.385 6.585a2.1 2.1 0 0 0 -2.97 -2.97l-8.415 8.385v3h3l8.385 -8.415z" />
                        <path d="M16 5l3 3" />
                      </svg>
                    </button>
                  )}
                </div>

                {field.name === "person-group" &&
                  editableFields?.["person-group"] && (
                    <PanelRefAuthorGroup
                      handleCancel={handleClose}
                      editor={editor}
                      show={editableFields?.["person-group"]}
                      refId={show?.edit?.open ? show?.edit?.id : show.add.id}
                      setData={setFormData}
                      authGroup={authGroup}
                      setAuthGroup={setAuthGroup}
                    />
                  )}
              </div>
            );
          })}

          <div className="ml-auto w-full">
            <div className="flex py-3 ml-auto justify-end gap-4">
              <button
                className=" px-[15px] py-1 rounded-[8px] hover:text-[#20c77c] border-[1px] border-grey hover:border-[#20c77c]"
                onClick={() => handleCancel()}
              >
                {" "}
                Cancel
              </button>
              <button
                className="px-[15px] py-1 bg-[#00b96b] text-white rounded-[8px] hover:bg-hoverbtnbg"
                onClick={(e) => handleSubmit(e)}
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};
export default PanelReferenceForm;
